import * as yup from 'yup';
import { eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';

const schemaDictionary = {
  loan_amount: {
    [eTransactionCategory.Purchase]: () => yup.number().nullable(),
    [eTransactionCategory.Refinance]: () => yup.number().nullable().required(),
  },
  estimated_property_value: () => yup.number().nullable(),
  purchase_price: {
    [eTransactionCategory.Refinance]: () => yup.number().nullable(),
    [eTransactionCategory.Purchase]: () => yup.number().nullable().required(),
  },
  loan_number: () => yup.string().nullable().required(),
};

export const SingleFieldValidationSchemaGenerator = (
  transaction_category: eTransactionCategory,
  fieldName: string | 'loan_amount' | 'purchase_price' | 'estimated_property_value' | 'loan_number'
) => {
  switch (fieldName) {
    case 'loan_amount':
    case 'purchase_price':
      return schemaDictionary[fieldName][transaction_category]();
    case 'estimated_property_value':
    case 'loan_number':
      return schemaDictionary[fieldName]();
  }
  throw Error('Not supported field');
};
